import { useEffect, useState } from "react";

// -----------------------------------------------------------------------------
//  useCuratedGallery — shared fetcher for the public curated gallery.
//
//  Multiple parts of the /hotels/:slug page need to know whether a hotel
//  has any curated images: the section itself renders the tiles, but the
//  sticky nav also wants to expose (or hide) the "Gallery" anchor
//  accordingly. Centralising the fetch here keeps both consumers in sync
//  without a second network round-trip.
//
//  Backend endpoint: GET /api/curated-galleries/{slug}
//    · Public read (no auth required)
//    · Already filters `hidden: true` server-side
//    · Preserves the order set by drag-and-drop reorder in /admin
// -----------------------------------------------------------------------------

const API = process.env.REACT_APP_BACKEND_URL || "";

const useCuratedGallery = (hotelSlug) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!hotelSlug) return undefined;
    let cancelled = false;
    setLoading(true);
    fetch(`${API}/api/curated-galleries/${hotelSlug}`)
      .then((res) => (res.ok ? res.json() : { images: [] }))
      .then((data) => {
        if (cancelled) return;
        setImages(Array.isArray(data.images) ? data.images : []);
      })
      .catch(() => {
        if (!cancelled) setImages([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [hotelSlug]);

  return { images, loading, count: images.length };
};

export default useCuratedGallery;
